import React from 'react';
import './plan-details.styles.scss';
import { membershipRestrictions } from '@/utils/membershipRestrictions';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';

const PlanDetails = () => {

  const screenSize = useSelector(state => state.contentData.screenSize)

  return (
    <div className={`plan-details ${screenSize}`}>
      <table className='g-table'>
        <thead>
          <tr>
            <td>Features</td>
            <td className='centered'>
              <div className='table-head'>
                <ImageContainer src="/images/icons/free.png" className="icon" />
                Basic Plan
              </div>
            </td>
            <td className='centered'>
              <div className='table-head'>
                <ImageContainer src="/images/icons/pro.png" className="icon" />
                Pro Plan
              </div>
            </td>
            <td className='centered'>
              <div className='table-head'>
                <ImageContainer src="/images/icons/premium.png" className="icon" />
                Premium
              </div>
            </td>
            <td className='centered'>
              <div className='table-head'>
                <ImageContainer src="/images/icons/enterprise.png" className="icon" />
                Enterprise
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Active Games</td>
            <td className='centered info'>
              {
                membershipRestrictions[0].gameCount
                  ?
                  membershipRestrictions[0].gameCount.toLocaleString()
                  :
                  'Unlimited'
              }
            </td>
            <td className='centered info'>
              {
                membershipRestrictions[1].gameCount
                  ?
                  membershipRestrictions[1].gameCount.toLocaleString()
                  :
                  'Unlimited'
              }
            </td>
            <td className='centered info'>
              {
                membershipRestrictions[2].gameCount
                  ?
                  membershipRestrictions[2].gameCount.toLocaleString()
                  :
                  'Unlimited'
              }
            </td>
            <td className='centered info'>
              {
                membershipRestrictions[3].gameCount
                  ?
                  membershipRestrictions[3].gameCount.toLocaleString()
                  :
                  'Unlimited'
              }
            </td>
          </tr>
          {/* <tr>
                                            <td>Cost Per Additional Game</td>
                                            <td className='centered info na'>X</td>
                                            <td className='centered info'>$10</td>
                                            <td className='centered info'>$5</td>
                                            <td className='centered info na'>X</td>
                                        </tr> */}
          <tr>
            <td>Game Elements Per Game</td>
            <td className='centered info'>
              {
                membershipRestrictions[0].elementCount
                  ?
                  membershipRestrictions[0].elementCount.toLocaleString()
                  :
                  'Unlimited'
              }
            </td>
            <td className='centered info'>{membershipRestrictions[1].elementCount ? membershipRestrictions[1].elementCount.toLocaleString() : 'Unlimited'}</td>
            <td className='centered info'>{membershipRestrictions[2].elementCount ? membershipRestrictions[2].elementCount.toLocaleString() : 'Unlimited'}</td>
            <td className='centered info'>{membershipRestrictions[3].elementCount ? membershipRestrictions[3].elementCount.toLocaleString() : 'Unlimited'}</td>
          </tr>
          <tr>
            <td>Players Per Game</td>
            <td className='centered info'>{membershipRestrictions[0].playerCount ? membershipRestrictions[0].playerCount.toLocaleString() : 'Unlimited'}</td>
            <td className='centered info'>{membershipRestrictions[1].playerCount ? membershipRestrictions[1].playerCount.toLocaleString() : 'Unlimited'}</td>
            <td className='centered info'>{membershipRestrictions[2].playerCount ? membershipRestrictions[2].playerCount.toLocaleString() : 'Unlimited'}</td>
            <td className='centered info'>{membershipRestrictions[3].playerCount ? membershipRestrictions[3].playerCount.toLocaleString() : 'Unlimited'}</td>
          </tr>
          {/* <tr>
                                            <td>Available Game Styles</td>
                                            <td className='centered info'>Points and Leaderboards or Currency and a Store</td>
                                            <td className='centered info'>All styles available</td>
                                            <td className='centered info'>All styles available</td>
                                            <td className='centered info'>All styles available</td>
                                        </tr> */}
          {/* <tr>
                                            <td>Access to Gamably Content Hub</td>
                                            <td className='centered info na'>X</td>
                                            <td className='centered info'>Access to Pro Content Only</td>
                                            <td className='centered info'>Full Access</td>
                                            <td className='centered info'>Full Access</td>
                                        </tr> */}
          <tr>
            <td>Access to Template Games</td>
            <td className='centered info'>Free Templates only</td>
            <td className='centered info'>Pro Templates Only</td>
            <td className='centered info'>All Templates</td>
            <td className='centered info'>All Templates</td>
          </tr>
          <tr>
            <td>Experience Points (XP)</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Leaderboards</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Badges</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>

          <tr>
            <td>Challenges</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Levels</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Currency & Items</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Marketplace</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Secret Codes</td>
            <td className='centered info na'>X</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>

          <tr>
            <td>Item Prize Packs</td>
            <td className='centered info na'>X</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Collections and Collectibles</td>
            <td className='centered info na'>X</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Contribution Items</td>
            <td className='centered info na'>X</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Lotteries</td>
            <td className='centered info na'>X</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td>Multi-Step Quests</td>
            <td className='centered info na'>X</td>
            <td className='centered info na'>X</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
          <tr>
            <td className="with-new-icon">
              Momentum Cards
              <ImageContainer s
                rc="/images/icons/new.png" 
                className="new-icon" 
                alt="New" />
            </td>
            <td className='centered info na'>X</td>
            <td className='centered info na'>X</td>
            <td className='centered info'>Yes</td>
            <td className='centered info'>Yes</td>
          </tr>
        </tbody>
      </table>

    </div>
  )
}

export default PlanDetails